function About() {
    return (
        <div>
            <h2>About Page</h2>
            <p>This is the about page for Slope Dashboard.</p>
        </div>
    );
}

export default About;
